import React, {PropTypes} from 'react';


const CardCheckbox = ({ className, checked, children, disabled, id, onChange, name, side, title, value }) => {
    if (side !== 'left' && side !== 'right') {
        return null;
    }

    className = className ? `checkbox ${className}`: 'checkbox';

    return (
        <div className={"card-checkbox " + className}>
            <div className={`checkbox-${side}${(side === 'left' ? ' order-1' : ' order-2')}`}>
                <input
                    name={name}
                    id={id}
                    type="checkbox"
                    title={title}
                    onChange={onChange}
                    checked={checked}
                    value={value}
                    disabled={disabled}
                />
            </div>
            <div className={`checkbox-text ${(side === 'left' ? 'order-2' : 'order-1')}`}>
                {children}
            </div>
        </div>
    );
};

CardCheckbox.propTypes = {
    className: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    onChange: PropTypes.func,
    name: PropTypes.string,
    side: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    value: PropTypes.bool
};

export default CardCheckbox;


/** WEBPACK FOOTER **
 ** ./src/components/bootstrap/CardCheckbox.js
 **/